import Popup from 'reactjs-popup';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
}

/** Matches the Modal.tsx pattern used across the other front/* React apps (e.g. nowy_kamiq,
 *  trade-in) — same reactjs-popup usage, same .modal/.modal__* class names. */
export default function Modal({ open, setOpen, children }: Props) {
  if (!open) {
    return null;
  }

  return (
    <Popup open={open} closeOnDocumentClick onClose={() => setOpen(false)}>
      <div className="modal">
        <div className="modal__content">
          <div className="modal__text">
            <div>{children}</div>
          </div>
          <div className="modal__button">
            <button className="button" type="button" onClick={() => setOpen(false)}>
              OK
            </button>
          </div>
        </div>
      </div>
    </Popup>
  );
}
